import { ProgramCodes } from '../enum';

function isAppCodeUseIdToken(appCode: string): boolean {
  return (
    appCode === ProgramCodes.LEMPG ||
    appCode === ProgramCodes.MITG ||
    appCode === ProgramCodes.REP ||
    appCode === ProgramCodes.VEOC ||
    appCode === ProgramCodes.DMA ||
    appCode === ProgramCodes.DMAM ||
    appCode === ProgramCodes.SERCLEPC ||
    appCode === ProgramCodes.EGRESS ||
    appCode === ProgramCodes.DECON ||
    appCode === ProgramCodes.DB30 ||
    appCode === ProgramCodes.MP30 ||
    appCode === ProgramCodes.EDMA ||
    appCode === ProgramCodes.EDMAP
  );
}

export default isAppCodeUseIdToken;
